import { Navigate, NavLink, Route, Routes } from "react-router-dom";
import { Images, MessageSquareText, Users } from "lucide-react";
import { MainImagePage } from "./pages/MainImagePage";
import { ReviewStudioPage } from "./pages/ReviewStudioPage";
import "./App.css";
import { AuthGate, UserAdmin } from './AuthGate';
import type { AuthUser } from './api';

export const standaloneNavigation = [
  { path: "/reviews", label: "评价生成", icon: MessageSquareText },
  { path: "/main-images", label: "主图管理", icon: Images },
] as const;

export const legacyRedirectPath = "/reviews";

export function resolveLocalAuthDisabled(value: string | undefined) {
  return value === "1";
}

const localAuthDisabled = resolveLocalAuthDisabled(import.meta.env.VITE_DISABLE_AUTH);
const localAdminUser: AuthUser = {
  id: 0,
  username: "local-workspace",
  phone: "",
  displayName: "本地工作区",
  role: "admin",
  status: "active",
  reason: "",
  mustChangePassword: false,
  lastLoginAt: null,
  createdAt: 0,
};

function Workspace({ user, accountsEnabled = true }: { user: AuthUser; accountsEnabled?: boolean }) {
  return (
    <div className="standalone-app">
      <aside className="standalone-sidebar">
        <div className="standalone-brand">
          <strong>简泽图文工作台</strong>
          <span>图片与评价内容生产</span>
        </div>
        <nav aria-label="功能导航">
          {standaloneNavigation.map(({ path, label, icon: Icon }) => (
            <NavLink key={path} to={path} className={({ isActive }) => (isActive ? "active" : "")}>
              <Icon size={19} aria-hidden="true" />
              <span>{label}</span>
            </NavLink>
          ))}
          {accountsEnabled && user.role === 'admin' && <NavLink to="/users" className={({isActive})=>isActive?'active':''}><Users size={19}/><span>用户管理</span></NavLink>}
        </nav>
        <div className="standalone-sidebar-note">
          <span className="status-dot" />
          GPT Image 2
        </div>
      </aside>

      <main className="standalone-main">
        <Routes>
          <Route
            path="/reviews"
            element={
              <ReviewStudioPage canManageProvider={user.role === "admin"} />
            }
          />
          <Route path="/main-images" element={<MainImagePage />} />
          {accountsEnabled && user.role === 'admin' && <Route path="/users" element={<UserAdmin currentUser={user} />} />}
          <Route path="/custom/*" element={<Navigate to={legacyRedirectPath} replace />} />
          <Route path="*" element={<Navigate to={legacyRedirectPath} replace />} />
        </Routes>
      </main>
    </div>
  );
}

function EmbeddedReviewsWorkspace({ user }: { user: AuthUser }) {
  return (
    <div className="standalone-app">
      <main className="standalone-main">
        <ReviewStudioPage canManageProvider={user.role === "admin"} />
      </main>
    </div>
  );
}

export function App() {
  if (localAuthDisabled) return <Workspace user={localAdminUser} accountsEnabled={false} />;
  return <AuthGate>{user => <Workspace user={user}/>}</AuthGate>;
}

export function EmbeddedReviewsApp() {
  return <EmbeddedReviewsWorkspace user={localAdminUser} />;
}
